import client from './client';

export type RuleActionType = 'alert' | 'webhook' | 'command' | 'broadcast';

export interface RuleAction {
  type: RuleActionType;
  params?: Record<string, unknown>;
}

export interface RuleItem {
  id: string;
  organizationId?: string | null;
  name: string;
  description?: string;
  enabled: boolean;
  priority: number;
  eventCodes?: string[] | null;
  conditions: Record<string, unknown>;
  actions: RuleAction[];
  cooldownMs: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface RuleExecutionItem {
  id: string;
  ruleId: string;
  ruleName: string;
  organizationId?: string | null;
  imei?: string;
  eventCode: string;
  actions?: Array<{ type: string; ok: boolean; ms: number; error?: string }>;
  durationMs: number;
  error?: string;
  createdAt: string;
}

export interface RuleTestResult {
  evaluated: number;
  triggered: Array<{
    ruleId: string;
    ruleName: string;
    actions: Array<{ type: string; ok: boolean; ms: number; result?: unknown }>;
  }>;
  errors: string[];
  dryRun?: boolean;
}

export const fetchRules = async (): Promise<RuleItem[]> => (await client.get('/rules')).data;

export const createRule = async (data: Partial<RuleItem>): Promise<RuleItem> =>
  (await client.post('/rules', data)).data;

export const updateRule = async (id: string, data: Partial<RuleItem>): Promise<RuleItem> =>
  (await client.patch(`/rules/${id}`, data)).data;

export const deleteRule = async (id: string): Promise<{ deleted: boolean }> =>
  (await client.delete(`/rules/${id}`)).data;

export const testRule = async (event: Record<string, unknown>): Promise<RuleTestResult> =>
  (await client.post('/rules/test', { event })).data;

// ── B3：AI 规则草稿（自然语言 → 规则 JSON；人工确认后保存） ──
export interface RuleDraft {
  name: string;
  description?: string;
  enabled: boolean;
  priority: number;
  eventCodes?: string[] | null;
  conditions: Record<string, unknown>;
  actions: RuleAction[];
  cooldownMs: number;
}

export const aiDraftRule = async (prompt: string): Promise<{ draft: RuleDraft; warnings: string[]; source: 'llm' }> =>
  (await client.post('/rules/ai-draft', { prompt })).data;

export const fetchRuleExecutions = async (params?: {
  ruleId?: string;
  imei?: string;
  limit?: number;
}): Promise<RuleExecutionItem[]> => (await client.get('/rules/executions', { params })).data;

export const RULE_ACTION_LABELS: Record<RuleActionType, string> = {
  alert: '告警（写入设备日志）',
  webhook: 'Webhook（HTTP 推送）',
  command: '设备命令（MQTT 下发）',
  broadcast: '实时广播（WS）',
};
